import type { ValidationStatus } from '../types'

/** Compute validation status from real funnel data (pure logic, no API call) */
export function getValidationStatus(
  stepsCount: number,
  hasRules: boolean
): ValidationStatus {
  const issues: ValidationStatus['issues'] = []

  if (stepsCount === 0) {
    issues.push({
      type: 'error',
      message: 'Funnel has no steps configured',
      field: 'steps',
    })
  }

  if (!hasRules) {
    issues.push({
      type: 'warning',
      message: 'No targeting rules defined',
      field: 'rules',
    })
  }

  if (stepsCount > 0 && stepsCount < 2) {
    issues.push({
      type: 'info',
      message: 'Consider adding more steps for better conversion',
      field: 'steps',
    })
  }

  const errorCount = issues.filter((i) => i.type === 'error').length
  const totalChecks = 5
  const passedChecks = totalChecks - issues.length

  return {
    isValid: errorCount === 0,
    completionPercent: Math.round((passedChecks / totalChecks) * 100),
    issues,
  }
}
